import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlumniFeedbackListComponent } from './alumni-feedback-list/alumni-feedback-list.component';
import { AlumniFeedbackViewComponent } from './alumni-feedback-view/alumni-feedback-view.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: AlumniFeedbackListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      /* {
        path: 'view-page',
        component: AlumniFeedbackViewComponent,
        data: {
          title: "View Page",
          breadcrumb: "View Page"
        }
      }, */
      {
        path: 'alumni-feedback-view/:id',
        component: AlumniFeedbackViewComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlumniFeedbackRoutingModule { }
